import { s__ } from '~/locale';

export const CLUSTER_FILTER_ERROR = s__('SecurityOrchestration|Failed to load cluster agents.');

export const IMAGE_FILTER_ERROR = s__('SecurityOrchestration|Failed to load images.');

export const TOOL_FILTER_ERROR = s__(
  'SecurityOrchestration|Failed to load vulnerability scanners.',
);

export const ALL_ID = 'ALL';
